import styled from 'styled-components';
import { spacing } from '@govuk-react/lib';

const MetaCustom = styled('div')({
  marginBottom: spacing.simple(4),
});

export default MetaCustom;
